module.exports = __webpack_public_path__ + "6275fb96161b3053f1c4d1bd33450d2d.fbx";